/**
 * AddNewSectionButton
 * -------------------
 * WHAT: Small "+ Add new section" button rendered at the bottom of a page in
 *       edit mode for Guides and Strategies (which allow free-form sections).
 *
 * WHY context instead of props: the actual "add section" logic lives in
 *      ContentViewerContext (it needs to mutate the content tree and open the
 *      new section for editing). This button doesn't need to know anything
 *      about the content — it just delegates.
 */
import { Button } from '@amzn/awsui-components-core';
import React, { useContext } from 'react';
import { ContentViewerContext } from '../workflow-viewer/ContentViewerContext';

export const AddNewSectionButton = () => {
  // `addNewSection` is provided by the nearest ContentViewerContext.Provider.
  //
  // BUG: if this component is mounted outside a Provider, `addNewSection` is
  // undefined and clicking the button will throw. No fallback/guard here.
  // Safe in practice because this is only rendered inside ContentDataForm,
  // which is always inside the provider.
  const { addNewSection } = useContext(ContentViewerContext);

  return (
    <Button iconName="add-plus" onClick={addNewSection}>
      {/* Hard-coded string — should probably live in constants.ts for i18n. */}
      {'Add new section'}
    </Button>
  );
};
